import React from 'react';
import styled from 'styled-components';
// import classNames from 'classnames'
import Glyphicon from './Glyphicon';

const ToggleButton = styled(Glyphicon)`
  float: left;
  padding: 0 10px;
  font-size: 125%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1002;
  
  // Ensure proper touch targets on mobile
  @media (max-width: 991px) {
    min-width: 44px;
    min-height: 44px;
    visibility: visible;
    opacity: 1;
  }
`;

// we should have a cute animation for that
export default ({isMenuExtended}) => (
  <ToggleButton
    glyph="menu-hamburger"
    isMenuExtended={isMenuExtended}
    label="Menu"
  />
);
